
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { AccordionBlockListItemModel } from 'fourwaves-shared';
import { Collapsible, RawHtml } from 'fourwaves-shared/components';

@Component({
  components: {
    Collapsible,
    RawHtml,
  },
})
export default class AccordionBlockListItem extends Vue {
  @Prop({ type: Object, required: true }) readonly item!: AccordionBlockListItemModel;
  @Prop({ type: Array, required: true }) readonly list!: AccordionBlockListItemModel[];
  @Prop({ type: Number, required: true }) readonly index!: number;

  public isOpen: boolean = false;

  get itemClassNames(): Record<string, boolean> {
    return { '-last': this.index === this.list.length - 1 };
  }
}
